import React, { useState } from 'react';
import Scoreboard from './Scoreboard/Scoreboard';
import PerformanceStats from './PerformanceStats/PerformanceStats';
import GameInfo from './GameInfo/GameInfo';
import EventVisibilityAndCalculations from './EventVisibilityAndCalculations/EventVisibilityAndCalculations';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { selectEvent } from '../../../redux/reducers/settingReducer';

const StreamingOverlays = () => {
  const dispatch = useDispatch()
  const [streamingOverlaysTab, setStreamingOverlaysTab] = useState('Scoreboard')
  localStorage.setItem("streamingOverlays", "");
  const eventTitle = localStorage.getItem("eventTitle");

  const handleNavigateTab = (tab) => {
   setStreamingOverlaysTab(tab);
  }
 const [selectedEvents, setSelectedEvents] = useState(false);
  const handleSelectEvent = (selectedOptions) => {
    // Create a map to store event codes and details by group code
    const groupEventsMap = {}; // { groupCode: [{ value, label }, ...] }

    selectedOptions.forEach((option) => {
      const eventCode = option.value.split(" ")[0]; // EC code
      const groupCode = option.value.split(" ")[1]; // GC code

      // If the groupCode is already present in the map, add the event details
      // If not, create an array and add the event details
      if (!groupEventsMap[groupCode]) {
        groupEventsMap[groupCode] = [];
      }
      groupEventsMap[groupCode].push({
        eventCode: eventCode.slice(2), // Store the event code without the EC prefix
        value: option.value,
        label: option.label
      });
    });

    // Flatten all event codes across all groups to dispatch
    const newValues = Object.values(groupEventsMap)
      .flat()
      .map(event => event.eventCode); // Extract only the event codes


    dispatch(selectEvent(newValues));

    // Save selected options grouped by group codes to local storage
    localStorage.setItem("selectedEventsOptions", JSON.stringify(groupEventsMap));

    // Save unique group codes in local storage
    const uniqueGroupCodes = Object.keys(groupEventsMap);
    localStorage.setItem("selectedGroupCodes", JSON.stringify(uniqueGroupCodes));


  setSelectedEvents(true)


  };
  return (
    <div>
      <div className='flex gap-5 items-center'>
        <p className='text-[#1A1A1A] font-bebas hidden md:block text-4xl'>Streaming Options</p>
        <div className='max-w-[500px] w-full'>
           <EventVisibilityAndCalculations handleSelectEvent={handleSelectEvent} />
       </div>
      </div>
      <div className='mt-4'>
        <div className='flex justify-center items-center gap-5 border-b-[1px] border-[#E8E8E8] flex-col md:flex-row'>
          {/* <div onClick={() => handleNavigateTab('EventVisibilityAndCalculations')} className={`font-rubik  capitalize ${streamingOverlaysTab === 'EventVisibilityAndCalculations' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'text-[#7D7D7D] border-b-0 font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Event Visibility & Calculations
          </div> */}
          <div onClick={() => handleNavigateTab('Scoreboard')} className={`font-rubik  capitalize ${streamingOverlaysTab === 'Scoreboard' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'text-[#7D7D7D] border-b-0 font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Scoreboard
          </div>
          <div onClick={() => handleNavigateTab('PerformanceStats')} className={`font-rubik capitalize  ${streamingOverlaysTab === 'PerformanceStats' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'border-b-0 text-[#7D7D7D] font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Performance stats
          </div>
          <div onClick={() => handleNavigateTab('GameInfo')} className={`font-rubik  capitalize ${streamingOverlaysTab === 'GameInfo' ? 'text-primary font-medium hover:text-secondary border-b-[2px] border-primary' : 'border-b-0 text-[#7D7D7D] font-normal'} text-xl  py-3 px-5 cursor-pointer w-full md:w-auto text-center`}>
            Game Info
          </div>
        </div>
        <div className='my-10' >
          {
            streamingOverlaysTab == 'Scoreboard' ? <Scoreboard selectedEvents={selectedEvents} /> :
              streamingOverlaysTab == 'PerformanceStats' ? <PerformanceStats /> :
                streamingOverlaysTab == 'GameInfo' ? <GameInfo /> :

                    <Scoreboard selectedEvents={selectedEvents} /> // Default component to render if settingsTab doesn't match any of the above conditions
          }
        </div>
      </div>
    </div>
  );
};

export default StreamingOverlays;